export const ConvertDate = (inputDateString) => {
    // Create a Date object from the input string
    let inputDate = new Date(inputDateString);

    // Extract the components (year, month, day, hours, minutes) from the Date object
    let year = inputDate.getFullYear();
    let month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's zero-based
    let day = String(inputDate.getDate()).padStart(2, '0');
    let hours = String(inputDate.getHours()).padStart(2, '0');
    let minutes = String(inputDate.getMinutes()).padStart(2, '0');

    // Create the desired output string
    return `${day}/${month}/${year} ${hours}:${minutes}`;
};
